import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/search.png'


const _withScopeId = n => (_pushScopeId("data-v-2f20b9c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-search"
}, null, -1))

import { RouteLocationRaw } from 'vue-router';

  interface IProps {
    text?: string;
    href?: string;
    to?: RouteLocationRaw;
    target?: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    text: null,
    href: null,
    to: null,
    target: null
  },
  emits: ['btnClick'],
  setup(__props: any, { emit: emits }) {

  

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.to ? 'router-link' : (__props.href ? 'a' : 'div')), _mergeProps(__props.to ? { to: __props.to } : { href: __props.href }, {
    target: __props.target,
    class: "emart-btn pointer",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('btnClick')))
  }), {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.text) + " ", 1),
      _renderSlot(_ctx.$slots, "default"),
      _hoisted_1
    ]),
    _: 3
  }, 16, ["target"]))
}
}

})